/**
 * Footer.js — The Wine Engine footer override.
 *
 * OVERRIDES: src/components/base/Footer.js
 *
 * Parity with old main.js footer:
 *   "powered by the wine engine" + theme.bot_avatar_url logo
 *   linking to https://thewineengine.com/
 *
 * RedConcierge branding stays for every other winery.
 */

import BaseFooter from "../../../components/base/Footer.js";
import { getTheme } from "../../../core/configAccessors.js";

export default class WineEngineFooter extends BaseFooter {
  render(ctx) {
    const footer = super.render(ctx);

    const brand = footer.querySelector(".ws-powered-brand");
    if (brand) brand.textContent = "the wine engine";

    const link = footer.querySelector(".ws-powered-link");
    if (link) {
      link.href = "https://thewineengine.com/";
    }

    const logo = footer.querySelector(".ws-powered-logo");
    if (logo) {
      const avatarUrl = getTheme("bot_avatar_url", null);
      if (avatarUrl) {
        logo.src = avatarUrl;
        logo.alt = "the wine engine";
      }
    }

    return footer;
  }
}
